import { render, staticRenderFns } from "./MonitorDeviceList.vue?vue&type=template&id=54b61c24&"
import script from "./MonitorDeviceList.vue?vue&type=script&lang=js&"
export * from "./MonitorDeviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports